import type { ReactNode } from 'react';

export function PageHead({
  crumb,
  title,
  subtitle,
}: {
  crumb: string;
  title: string;
  subtitle?: ReactNode;
}) {
  return (
    <header className="report-head">
      <div className="report-crumb">{crumb}</div>
      <h1 className="report-title">{title}</h1>
      {subtitle && <p className="report-sub muted">{subtitle}</p>}
    </header>
  );
}
